module.exports = __webpack_public_path__ + "img/logowithgold.99add14f.png";